import axios from 'axios'
require('dotenv').config()

const backend = process.env.REACT_APP_BACKEND

async function getPlaygroundData(query = "") {
  const { data } = await axios.get(`${backend}data-aggregation/get-playground-data?${query}`)
  return data
}

export {
  getPlaygroundData
}
